import type { FC } from "react"

import { studioToScreen } from "@logic/lib/design"
import { useRecoilValue } from "recoil"

import { zoomState } from "~/containers/LegacyDesigner/state/view"

import { areaIndex, findInsetAreaFacesState } from "../../../state/elements"

const EdgeLabel: FC<{ id: string }> = ({ id }) => {
  const {
    procedure: { insetsAndLinks },
  } = useRecoilValue(findInsetAreaFacesState(id))
  const zoom = useRecoilValue(zoomState)

  return (
    <>
      {insetsAndLinks.map(({ alphaCode, p1, p2, type }) => {
        const halfwayBetween = studioToScreen.point(
          {
            x: (p1.x + p2.x) / 2,
            y: (p1.y + p2.y) / 2,
          },
          zoom,
        )

        return (
          <g key={`edgeLabel_` + id + `_` + alphaCode}>
            <circle
              cx={halfwayBetween.x}
              cy={halfwayBetween.y}
              r={10}
              fill={type === `inset` ? `cyan` : `#c0f`}
            />
            <text
              x={halfwayBetween.x}
              y={halfwayBetween.y + 7}
              textAnchor="middle"
              fill={type === `inset` ? `black` : `white`}
              fontSize={8}
            >
              {alphaCode}
            </text>
          </g>
        )
      })}
    </>
  )
}

export const EdgeLabels: FC = () => {
  const areaIds = useRecoilValue(areaIndex)

  return (
    <>
      {areaIds.map((id) => (
        <EdgeLabel id={id} key={`label_` + id} />
      ))}
    </>
  )
}
